import React, { useState, useEffect, useRef } from "react";
import "./index.scss";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { LinearProgress, Typography, Avatar, useTheme, useMediaQuery, Grid } from "@mui/material";
import { Swiper, SwiperSlide } from 'swiper/react';
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import PauseCircleFilledIcon from "@mui/icons-material/PauseCircleFilled";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import CloseIcon from "@mui/icons-material/Close";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import champLogo from "../../assets/images/icons/storyIcon.png";
import profilePic from "../../assets/images/icons/userProfile.png";
import profile from "../../assets/images/story/profile.png";
import ballIcon from "../../assets/images/story/ball.png";
import video1 from "../../assets/images/story/video.mp4";
import video2 from "../../assets/images/story/random1 (1).mp4";
import video3 from "../../assets/images/story/random2.mp4";

const style = {
    height: "100vh !important",
    width: "100vw !important",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "2px solid #000",
    p: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "#141414",
};

const textStyle = {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px",
    color: "#FFFFFF",
};

const StyledInput = styled("input")(({ theme }) => ({
    fontFamily: "Inter, sans-serif", // Ensure 'Inter' font is loaded in your project
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "19px",
    color: "#FFFFFF",
    border: "1px solid #FFFFFF",
    outline: "none",
    borderRadius: "30px",
    padding: "8px 15px",
    width: "75%",
    background: "transparent",
    "&::placeholder": {
        color: "#FFFFFF",
        opacity: 1,
    },
    "&:focus": {
        borderColor: "#FFFF",
    },
}));


//Fake data will remove while integarting api
const stories = [
    { id: 1, name: "Amar Bro", profilePic: profilePic },
    { id: 2, name: "Maya Anand", profilePic: profilePic },
    { id: 3, name: "Sara Ali", profilePic: profilePic },
    { id: 4, name: "Raj Patel", profilePic: profilePic },
    { id: 5, name: "John Doe", profilePic: profilePic },
    { id: 7, name: "Rishi Singh", profilePic: profilePic },
    { id: 8, name: "Maya Anand", profilePic: profilePic },
    { id: 9, name: "Sara Ali", profilePic: profilePic },
    { id: 10, name: "Raj Patel", profilePic: profilePic },
    { id: 11, name: "John Doe", profilePic: profilePic },
];

const slides = [
    {
        id: 1,
        videoUrl: video1,
        name: 'John Doe',
        userProfilePic: profile,
        time: '20 mins ago'
    },
    {
        id: 2,
        videoUrl: video2,
        name: 'Jane Smith',
        userProfilePic: ballIcon,
        time: '1 hour ago'
    },
    {
        id: 3,
        videoUrl: video3,
        name: 'Alice Johnson',
        userProfilePic: profilePic,
        time: 'Yesterday'
    }
];

const Story = () => {
    const [openModal, setOpenModal] = useState(false);
    const [progress, setProgress] = useState(0);
    const [currentSlide, setCurrentSlide] = useState(1);
    const [isStoryPlaying, setIsStoryPlaying] = useState(true);
    const [isAudioMuted, setIsAudioMuted] = useState(false);
    const storyRef = useRef(null);
    const mobileView = useMediaQuery("(max-width:600px)");
    const mobileView2 = useMediaQuery("(max-width:769px)");

    // For circular slide
    const mod = (n, m) => ((n % m) + m) % m;
    const prevIndex = mod(currentSlide - 1, slides.length);
    const nextIndex = mod(currentSlide + 1, slides.length);

    const handleClick = () => { setOpenModal(true); }; //HandleOpenModel
    const slideNext = () => { setCurrentSlide((prev) => mod(prev + 1, slides.length)); }; //Handle next slide
    const slidePrev = () => { setCurrentSlide((prev) => mod(prev - 1, slides.length)); }; //Handle prev slide

    // Handle story play pause
    const togglePlayPause = () => {
        if (storyRef.current) {
            if (isStoryPlaying) {
                storyRef.current.pause();
            } else {
                storyRef.current.play();
            }
            setIsStoryPlaying(!isStoryPlaying);
        }
    };

    // Handle audio mute unmute
    const toggleMute = () => {
        if (storyRef.current) {
            storyRef.current.muted = !isAudioMuted;
            setIsAudioMuted(!isAudioMuted);
        }
    };

    // Handle story progress
    useEffect(() => {
        const interval = setInterval(() => {
            if (storyRef.current) {
                const percent =
                    (storyRef.current.currentTime / storyRef.current.duration) * 100;
                setProgress(percent);
            }
        }, 100);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="story-main-container">
            <div className="stories-slider">
                <div className="add-story">
                    <img className="add-story-logo" src={champLogo} alt="Add Story" />
                    <p className="add-story-name">Add Story</p>
                </div>
                {stories.map((story) => (
                    <div
                        key={story.id}
                        className="following-stories"
                        onClick={handleClick}
                    >
                        <div className="following-profile-container">
                            <img
                                className="following-profile"
                                src={story.profilePic || champLogo}
                                alt={story.name}
                            />
                        </div>
                        <p className="following-name">{story.name}</p>
                    </div>
                ))}
            </div>
            <Modal
                open={openModal}
                onClose={() => {
                    setOpenModal(false);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box sx={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        position: "absolute",
                        top: 25,
                        left: "8.4rem",
                        '@media (max-width: 769px)': {
                            display: "none"
                        }
                    }}>
                        <Avatar src={champLogo} alt='' sx={{ width: "30px", height: "30px" }} />
                        <Typography sx={{
                            fontFamily: "Inter",
                            fontSize: "23px",
                            fontWeight: "500",
                            lineHeight: "23px",
                            color: "#FFFFFF",
                        }}>
                            CHAMPHUNT
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4%",
                            '@media (max-width: 769px)': {
                                gap: "1%",
                                position: "absolute",
                            }
                        }}
                    >
                        <Box
                            sx={{
                                width: "197px",
                                height: "300px",
                                borderRadius: "20px",
                                position: "relative",
                                backgroundImage: "linear-gradient(180deg, rgba(38, 38, 38, 0.8) 0%, rgba(38, 38, 38, 0) 100%, #000000 100%)",
                                '@media (max-width: 769px)': {
                                    display: "none"
                                }
                            }}
                        >
                            <video style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                zIndex: 0,
                                borderRadius: "20px",
                            }}
                                src={slides[prevIndex].videoUrl}
                                loop
                                muted
                            />
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "10px",
                                position: "absolute",
                                top: "100px",
                                left: "60px",
                                zIndex: 1,
                            }}>
                                <Avatar
                                    src={slides[prevIndex].userProfilePic}
                                    alt=""
                                    sx={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                    }}
                                />
                                <Typography sx={textStyle}>{slides[prevIndex].name}</Typography>
                                <Typography sx={textStyle}>{slides[prevIndex].time}</Typography>
                            </Box>
                        </Box>
                        <IconButton
                            onClick={slidePrev}
                            sx={{
                                width: "40px",
                                height: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "#494D50",
                                borderRadius: "50%",
                                paddingLeft: "18px",
                                '&:hover': {
                                    background: "#494D50",
                                },
                                '@media (max-width: 769px)': {
                                    display: "none"
                                }
                            }}
                        >
                            <ArrowBackIosIcon />
                        </IconButton>
                        <Box
                            sx={{
                                width: "30%",
                                height: "93vh",
                                position: "relative",
                                '@media (max-width: 769px)': {
                                    width: "100%",
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "100px",
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: "15px 15px 0px 15px",
                                    gap: "25px",
                                    backgroundImage: "linear-gradient(180deg, rgba(38, 38, 38, 0.8) 0%, rgba(38, 38, 38, 0) 100%)",
                                }}
                            >
                                <Box>
                                    <LinearProgress
                                        variant="determinate"
                                        value={progress}
                                        size={80}
                                        thickness={4}
                                        sx={{ color: progress === 100 ? "#4caf50" : "#FFFFFF59" }}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <Avatar
                                            src={slides[currentSlide].userProfilePic}
                                            alt=""
                                            sx={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                            }}
                                        />
                                        <Typography sx={textStyle}>{slides[currentSlide].name}</Typography>
                                        <Typography sx={textStyle}>{slides[currentSlide].time}</Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <IconButton onClick={togglePlayPause} sx={{
                                            '@media (max-width: 769px)': {
                                                display: "none",
                                            }
                                        }}>
                                            {isStoryPlaying ? (
                                                <PauseCircleFilledIcon sx={{ color: "#FFFFFF" }} />
                                            ) : (
                                                <PlayCircleFilledIcon sx={{ color: "#FFFFFF" }} />
                                            )}
                                        </IconButton>
                                        <IconButton onClick={toggleMute} sx={{
                                            '@media (max-width: 769px)': {
                                                display: "none",
                                            }
                                        }}>
                                            {isAudioMuted ? (
                                                <VolumeOffIcon sx={{ color: "#FFFFFF" }} />
                                            ) : (
                                                <VolumeUpIcon sx={{ color: "#FFFFFF" }} />
                                            )}
                                        </IconButton>
                                        {mobileView2 ? (
                                            <IconButton sx={{
                                                display: "flex",
                                                gap: "10px",
                                            }}>
                                                <MoreHorizIcon sx={{ color: "#FFFFFF" }} />
                                                <CloseIcon onClick={() => setOpenModal(false)} sx={{ color: "#FFFFFF" }} />
                                            </IconButton>
                                        ) : (
                                            <IconButton>
                                                <MoreVertIcon sx={{ color: "#FFFFFF" }} />
                                            </IconButton>
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    width: "100%",
                                    height: `calc(93vh - 100px)`,
                                }}
                            >
                                <video
                                    ref={storyRef}
                                    key={currentSlide}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                    src={slides[currentSlide].videoUrl}
                                    type="video/mp4"
                                    loop
                                    autoPlay
                                    muted={isAudioMuted}
                                    onPlay={() => setIsStoryPlaying(true)}
                                    onEnded={() => setProgress(100)}
                                />
                            </Box>
                            {/* <Box style={{
                                display: "flex",
                                width: "100%",
                                height: "55px",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "10px",
                                position: "absolute",
                                top: "34.1rem",
                                backgroundImage: "linear-gradient(0deg, rgba(0, 0, 0, 0.38) 0%, #000000 100%)"
                            }}>
                                <StyledInput type="text" placeholder="Reply to username..." />
                                <img src={ballIcon} alt='' style={{ width: "40px", height: "40px" }} />
                            </Box> */}
                        </Box>
                        <IconButton
                            onClick={slideNext}
                            sx={{
                                width: "40px",
                                height: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "#494D50",
                                borderRadius: "50%",
                                '&:hover': {
                                    background: "#494D50",
                                },
                                '@media (max-width: 769px)': {
                                    display: "none"
                                }
                            }}
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                        <Box
                            sx={{
                                width: "197px",
                                height: "300px",
                                borderRadius: "20px",
                                position: "relative",
                                backgroundImage: "linear-gradient(180deg, rgba(38, 38, 38, 0.8) 0%, rgba(38, 38, 38, 0) 100%, #000000 100%)",
                                '@media (max-width: 769px)': {
                                    display: "none"
                                }
                            }}
                        >
                            <video style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                zIndex: 0,
                                borderRadius: "20px",
                            }}
                                src={slides[nextIndex].videoUrl}
                                loop
                                muted
                            />
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "10px",
                                position: "absolute",
                                top: "100px",
                                left: "60px",
                                zIndex: 1,
                            }}>
                                <Avatar
                                    src={slides[nextIndex].userProfilePic}
                                    alt=""
                                    sx={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                    }}
                                />
                                <Typography sx={textStyle}>{slides[nextIndex].name}</Typography>
                                <Typography sx={textStyle}>{slides[nextIndex].time}</Typography>
                            </Box>
                        </Box>
                    </Box>
                    <IconButton
                        onClick={() => setOpenModal(false)}
                        sx={{
                            position: "absolute", top: 8, right: 8,
                            '@media (max-width: 769px)': {
                                display: "none",
                            }
                        }}
                    >
                        <CloseIcon sx={{ color: "#FFFFFF" }} />
                    </IconButton>
                </Box>
            </Modal>
        </div >
    );
};

export default Story;